import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as m } from '../../constants/Podcasts';
import Badge from '../lib/Badge/Badge';

import './PodcastProgramMetadata.scss';

class PodcastProgramMetadata extends React.Component {
  static propTypes = {
    episodeCount: PropTypes.number,
    collectedEpisodeCount: PropTypes.number,
    showSourceName: PropTypes.bool,
    showNewBadge: PropTypes.bool,
  };

  getProgramEpisodeCount = () => {
    const { episodeCount, collectedEpisodeCount } = this.props;
    if (collectedEpisodeCount) {
      return (
        <FormattedMessage {...m.collectedEpisodeCount} values={{ count: collectedEpisodeCount }} />
      );
    } else if (episodeCount) {
      return <FormattedMessage {...m.episodeCount} values={{ count: episodeCount }} />;
    }

    return null;
  };

  getProgramMetadataText = () => {
    const { showSourceName } = this.props;
    const programEpisodeCount = this.getProgramEpisodeCount();

    if (showSourceName && programEpisodeCount) {
      return (
        <FormattedMessage
          {...m.metadataTexts}
          values={{
            leftText: <FormattedMessage {...m.podcast} />,
            rightText: programEpisodeCount,
          }}
        />
      );
    }

    return programEpisodeCount || null;
  };

  render() {
    const badgeText = <FormattedMessage {...m.newBadge} />;

    return (
      <div className='PodcastProgramMetadata'>
        <span className='PodcastProgramMetadata__text'>{this.getProgramMetadataText()}</span>
        {this.props.showNewBadge && <Badge isBlue={true} isInline={true} badgeText={badgeText} />}
      </div>
    );
  }
}

export default PodcastProgramMetadata;
